import React from 'react';
import config from 'config';
import {
  Map,
  InfoWindow,
  Marker,
  GoogleApiWrapper,
  Polyline,
} from 'google-maps-react';
import { getBounds, getMarker, getPolyline } from 'services/Geolocation';

export const MapContainer = (props) => {
  const onMarkerClick = () => {};
  const state = {};
  const [height, setHeight] = React.useState(0);
  const [bounds, setBounds] = React.useState(undefined);
  const [polyline, setPolyline] = React.useState([]);
  const [polylineAttributes, setPolylineAttributes] = React.useState({});

  React.useEffect(() => {
    props.bounds && setBounds(getBounds(props.bounds, props.google));
  }, [props.bounds]);

  React.useEffect(() => {
    (props.googleRef || (() => {}))(props.google);
  }, [props.google]);

  React.useEffect(() => {
    if (
      props.polyline &&
      props.polylineJourney.pickup &&
      props.polylineJourney.destination
    ) {
      setPolylineAttributes(props.polylineAttributes || {});
      getPolyline(props.polylineJourney, props.google, setPolyline);
    }
  }, [props.polylineJourney, props.google]);

  return (
    <Map
      centerAroundCurrentLocation={props.centerAroundCurrentLocation}
      google={props.google}
      containerStyle={props.containerStyle}
      style={{
        ...(props.style || {}),
        padding: 0,
        margin: 0,
        position: 'absolute',
        bottom: 0,
      }}
      bounds={bounds}
      initialCenter={props.initialCenter}
      streetViewControl={false}
      fullscreenControl={false}
      rotateControl={false}
      mapTypeControl={false}
      center={props.center}
      zoom={props.zoom || 14}
      onDragend={props.onMapDrag}
      onClick={props.onMapClick}
    >
      {(props.markers || []).map((marker) =>
        getMarker({ ...(marker || {}), google: props.google })
      )}
      <Polyline
        path={polyline}
        strokeColor={polylineAttributes.color || '#8888ff'}
        strokeOpacity={polylineAttributes.opacity || 1}
        strokeWeight={polylineAttributes.weight || 5}
      />
    </Map>
  );
};

const MapComponent = GoogleApiWrapper({
  apiKey: config.mapsAPIKey,
})(MapContainer);

export default MapComponent;
